import { dataLayerPublish } from '@dhl/datalayer'

export function logException(error: unknown) {
  if (error instanceof Error) {
    dataLayerPublish('ERROR', {
      id: 'logException',
      error,
    })
  } else {
    dataLayerPublish('ERROR', {
      id: 'logException',
      error: JSON.stringify(error),
    })
  }
}
